<template>
  <div class="min-h-screen bg-background">
    <LazyDealershipHeader hydrate-on-visible />
    <main>
      <NuxtPage />
    </main>
    <TheFooter />
  </div>
</template>